import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6502">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6503">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6504">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6505">
            <ArrowLeft className="w-4 h-4" data-id="element-6506" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6507">NOIZA</div>
          <div className="w-20" data-id="element-6508" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6509">
        <div className="mb-12" data-id="element-6510">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6511">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6512" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6513">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6514">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6515">
          <section data-id="element-6516">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6517">
              <span className="text-[#006847]" data-id="element-6518">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6519">
              <p data-id="element-6520">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6521">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6522">
                <li data-id="element-6523">Haber leído íntegramente este documento</li>
                <li data-id="element-6524">Comprender su contenido en su totalidad</li>
                <li data-id="element-6525">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6526">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6527">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6528">
              <span className="text-[#006847]" data-id="element-6529">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6530">
              <p data-id="element-6531">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6532">
                <li data-id="element-6533">Software como servicio (SaaS)</li>
                <li data-id="element-6534">Marketplace digital gastronómico</li>
                <li data-id="element-6535">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6536">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6537">
                <li data-id="element-6538">Mostrar su menú digital</li>
                <li data-id="element-6539">Recibir pedidos de clientes</li>
                <li data-id="element-6540">Gestionar su operación interna</li>
                <li data-id="element-6541">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6542">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6543">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6544">
              <span className="text-[#006847]" data-id="element-6545">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6546">
              <p data-id="element-6547">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6548">
                <li data-id="element-6549">No es proveedor de alimentos</li>
                <li data-id="element-6550">No participa en la preparación de productos</li>
                <li data-id="element-6551">No manipula alimentos en ningún momento</li>
                <li data-id="element-6552">No realiza entregas ni logística</li>
                <li data-id="element-6553">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6554">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6555">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6556">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6557">
              <span className="text-[#006847]" data-id="element-6558">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6559">
              <p data-id="element-6560">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6561">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6562">
                <li data-id="element-6563">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6564">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6565">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6566">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6567">
                <li data-id="element-6568">Precios</li>
                <li data-id="element-6569">Menú</li>
                <li data-id="element-6570">Horarios</li>
                <li data-id="element-6571">Métodos de pago</li>
                <li data-id="element-6572">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6573">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6574">
              <span className="text-[#006847]" data-id="element-6575">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6576">
              <div data-id="element-6577">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6578">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6579">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6580">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6581">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6582">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6583">
                  <li data-id="element-6584">Calidad de los alimentos</li>
                  <li data-id="element-6585">Estado, frescura o preparación</li>
                  <li data-id="element-6586">Ingredientes utilizados</li>
                  <li data-id="element-6587">Contaminación cruzada</li>
                  <li data-id="element-6588">Problemas de higiene o salubridad</li>
                  <li data-id="element-6589">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6590">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6591">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6592">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6593">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6594">
                  <li data-id="element-6595">Retrasos en la entrega</li>
                  <li data-id="element-6596">Pérdida de pedidos</li>
                  <li data-id="element-6597">Entregas incompletas</li>
                  <li data-id="element-6598">Errores en dirección</li>
                  <li data-id="element-6599">Conducta de repartidores</li>
                  <li data-id="element-6600">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6601">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6602">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6603">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6604">
                  <li data-id="element-6605">Recepción de pagos</li>
                  <li data-id="element-6606">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6607">Manejo de efectivo</li>
                  <li data-id="element-6608">Confirmación de pagos</li>
                  <li data-id="element-6609">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6610">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6611">
                  <li data-id="element-6612">Pagos no recibidos</li>
                  <li data-id="element-6613">Comprobantes falsos</li>
                  <li data-id="element-6614">Errores en montos</li>
                  <li data-id="element-6615">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6616">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6617">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6618">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6619">
                  <li data-id="element-6620">Reclamos de clientes</li>
                  <li data-id="element-6621">Reembolsos</li>
                  <li data-id="element-6622">Cancelaciones</li>
                  <li data-id="element-6623">Disputas</li>
                  <li data-id="element-6624">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6625">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6626">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6627">
              <span className="text-[#006847]" data-id="element-6628">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6629">
              <p data-id="element-6630">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6631">
                <li data-id="element-6632">Responsable</li>
                <li data-id="element-6633">Legal</li>
                <li data-id="element-6634">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6635">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6636">
                <li data-id="element-6637">Publicar información falsa</li>
                <li data-id="element-6638">Manipular precios de forma engañosa</li>
                <li data-id="element-6639">Simular disponibilidad inexistente</li>
                <li data-id="element-6640">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6641">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6642">
              <span className="text-[#006847]" data-id="element-6643">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6644">
              <p data-id="element-6645">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6646">
                <li data-id="element-6647">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6648">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6649">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6650">
                <li data-id="element-6651">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6652">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6653">
                    <li data-id="element-6654">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6655">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6656">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6657">
              <span className="text-[#006847]" data-id="element-6658">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6659">
              <p data-id="element-6660">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6661">
                <li data-id="element-6662">Menú digital</li>
                <li data-id="element-6663">Gestión de pedidos</li>
                <li data-id="element-6664">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6665">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6666">
                  <p className="font-medium text-white mb-2" data-id="element-6667">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6668">
                    <li data-id="element-6669">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6670">
                  <p className="font-medium text-white mb-2" data-id="element-6671">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6672">
                    <li data-id="element-6673">Propiedad del software</li>
                    <li data-id="element-6674">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6675">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6676">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6677">
              <span className="text-[#006847]" data-id="element-6678">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6679">
              <p data-id="element-6680">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6681">
                <li data-id="element-6682">Disponibilidad continua</li>
                <li data-id="element-6683">Funcionamiento sin interrupciones</li>
                <li data-id="element-6684">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6685">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6686">
                <li data-id="element-6687">Fallas técnicas</li>
                <li data-id="element-6688">Actualizaciones</li>
                <li data-id="element-6689">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6690">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6691">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6692">
              <span className="text-[#006847]" data-id="element-6693">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6694">
              <p data-id="element-6695">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6696">
                <li data-id="element-6697">No está garantizada permanentemente</li>
                <li data-id="element-6698">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6699">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6700">
                <li data-id="element-6701">Destacar o no restaurantes</li>
                <li data-id="element-6702">Modificar posiciones</li>
                <li data-id="element-6703">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6704">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6705">
              <span className="text-[#006847]" data-id="element-6706">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6707">
              <p data-id="element-6708">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6709">
                <li data-id="element-6710">Cumplir con los pagos acordados</li>
                <li data-id="element-6711">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6712">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6713">
                <li data-id="element-6714">Suspender el servicio</li>
                <li data-id="element-6715">Limitar funcionalidades</li>
                <li data-id="element-6716">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6717">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6718">
              <span className="text-[#006847]" data-id="element-6719">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6720">
              <p data-id="element-6721">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6722">
                <li data-id="element-6723">Incumplimiento de términos</li>
                <li data-id="element-6724">Uso indebido</li>
                <li data-id="element-6725">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6726">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6727">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6728">
              <span className="text-[#006847]" data-id="element-6729">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6730">
              <p data-id="element-6731">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6732">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6733">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6734">
              <span className="text-[#006847]" data-id="element-6735">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6736">
              <p data-id="element-6737">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6738">
                <li data-id="element-6739">Pérdidas económicas</li>
                <li data-id="element-6740">Daños indirectos</li>
                <li data-id="element-6741">Lucro cesante</li>
                <li data-id="element-6742">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6743">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6744">
              <span className="text-[#006847]" data-id="element-6745">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6746">
              <p data-id="element-6747">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6748">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6749">
              <span className="text-[#006847]" data-id="element-6750">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6751">
              <p className="font-medium" data-id="element-6752">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6753">
                <li data-id="element-6754">Ha leído este documento completo</li>
                <li data-id="element-6755">Comprende su alcance</li>
                <li data-id="element-6756">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}